import { api } from '@/utils/api';

export const useGenerateUploadUrlMutation = () => {
  return api.audioFile.generateUploadUrl.useMutation({});
};

export const useMakePublicAudioFileUrlMutation = () => {
  return api.audioFile.makePublicAudioFileUrl.useMutation({});
};

export const useGenerateAiAudioMutation = () => {
  return api.audioFile.generateAiAudio.useMutation({});
};

export const useContactGenerateVoiceNoteAudioMutation = () => {
  const utils = api.useUtils();
  return api.contact.generateVoiceNoteAudio.useMutation({
    onSuccess: (_data, variables) => {
      // Creates a waiting voice-note step; the contact-detail action section
      // (aiStep.actionSectionData) lists it, so refresh that query.
      void utils.aiStep.actionSectionData.invalidate({
        contactId: variables.contactId,
        teamId: variables.teamId,
        userId: variables.userId,
      });
    },
  });
};

export const useContactApproveVoiceNoteStepMutation = () => {
  const utils = api.useUtils();
  return api.contact.approveVoiceNoteStep.useMutation({
    // Input only carries stepId (no contactId), so invalidate the action
    // section broadly. Approving schedules the step, so refresh the next step.
    onSuccess: () => {
      void utils.aiStep.actionSectionData.invalidate();
      void utils.steps.universalNextOne.invalidate();
    },
  });
};

export const useContactCreateVoiceNoteStepMutation = () => {
  const utils = api.useUtils();
  return api.contact.createVoiceNoteStep.useMutation({
    // Creates and auto-approves the step, making it executable.
    onSuccess: (_data, variables) => {
      void utils.aiStep.actionSectionData.invalidate({
        contactId: variables.contactId,
        teamId: variables.teamId,
        userId: variables.userId,
      });
      void utils.steps.universalNextOne.invalidate();
    },
  });
};